import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule, Routes,RouterStateSnapshot } from '@angular/router';
import { AppComponent } from './app.component';
import { ConfigureComponent } from './components/configure/configure.component';
import { StreamingComponent } from './components/streaming/streaming.component';
import { WebviewDirective } from './modules/webview-directive';

import { HttpModule } from '@angular/http';
import {HttpClientModule,HttpClient} from '@angular/common/http';
import { RoundPipe } from './modules/roundpipe.module';
import { DatePipe } from '@angular/common';
import { SafePipe } from './modules/secure_url.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { EscapeHtmlPipe } from './modules/keep-html';

import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgBufferingModule } from 'videogular2/buffering';
import { UiSwitchModule } from 'ngx-ui-switch';
import { WebCamComponent } from 'ack-angular-webcam';

//SERVICES
import { AuthService } from './services/auth.service';
//import { AccountService } from './services/account.service';
import { AuthGuard } from './services/auth.guard';
import { StreamingService } from './services/streaming.service';
import { FileuploadService } from './services/fileupload.service';
import { environment } from '../environments/environment';
import { IndexComponent } from './components/index/index.component';

import { AppService } from './services/app.service';

const appRoutes: Routes = [
  {
    path: 'configure',
    component: ConfigureComponent,
  },
  {
    path:'streaming/:id',
    component:StreamingComponent,
    //canActivate: [AuthGuard]
  },
  { 
    path: ':screen_id',
    component:IndexComponent,
    pathMatch: 'full',
  },
  { 
    path: '',
    component:IndexComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  declarations: [
    AppComponent,
    ConfigureComponent,
    StreamingComponent,
    WebCamComponent,
    RoundPipe,
    IndexComponent,
    SafePipe,
    EscapeHtmlPipe,
    WebviewDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,

    RouterModule.forRoot(appRoutes),
    VgCoreModule,
    VgControlsModule,
    VgBufferingModule,
    UiSwitchModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [StreamingService,AuthService,AuthGuard,DatePipe,FileuploadService,AppService,SafePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}



// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/app.module.ts